import React, { useState } from "react";
import { Drawer, Form, Select, Button, Row, Col, Typography, Divider, Input } from "antd";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';
import NewWarehouse from "./NewWarehouse";
import { BASE_API } from "../Config/Config";
import { getValue } from "@testing-library/user-event/dist/utils";

const ModifyWarehouseDrawer = ({ open, onClose, dropdown, fetchWarehouselist }) => {
    const { t } = useTranslation();
    const [isEditingUser, setIsEditingUser] = useState(false);

    const [form] = Form.useForm();
    const [regionForm] = Form.useForm();
    const userDetails = JSON.parse(sessionStorage.getItem("userdetails"));

    const [WarehouseDD, setWarehouseDD] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [EditWarehouse, setEditWarehouse] = useState(null);
    const [originalWarehouse, setOriginalWarehouse] = useState(null);
    const [inputUrl, setInputUrl] = useState('');
    const [showVideo, setShowVideo] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [showRegionModal, setShowRegionModal] = useState(false);

    const { Option } = Select;
    const { Text } = Typography;

    const handleUpdateMap = () => {
        setEditWarehouse(prev => ({
            ...prev,
            map: inputUrl
        }));
    };

    const [images, setImages] = useState([
        "https://via.placeholder.com/150",
        "https://via.placeholder.com/160",
        "https://via.placeholder.com/170",
    ]); // initial images

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);

    // Open modal at clicked image
    const openModal = (index) => {
        setCurrentIndex(index);
        setShowModal(true);
    };
    
    // Navigate images in modal
    const nextImage = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };
    const prevImage = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };
    
    // Remove current image
    const removeImage = () => {
        const newImages = [...images];
        newImages.splice(currentIndex, 1);
        setImages(newImages);
        if (currentIndex >= newImages.length) setCurrentIndex(newImages.length - 1);
        if (newImages.length === 0) setShowModal(false);
    };
   
    // Add new image
    const addImage = () => {
        const url = prompt("Enter image URL");
        if (url) setImages([...images, url]);
    };

    const onsubmit = async () => {
        try {
            const formData = new FormData();
            formData.append("wh_id", selectedWarehouse);
            formData.append("region", selectedRegion);

            const response = await fetch(
                `${BASE_API}/apis/WarehouseModification.php`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include"
                }
            );

            const result = await response.json();

            if (
                result.status === "success" &&
                Array.isArray(result.data)
            ) {
                setEditWarehouse(result?.data[0])
                setOriginalWarehouse(result.data[0])
            } else {
                setEditWarehouse(null);
                setOriginalWarehouse(null);
            }
        } catch (err) {
            console.error("Fetch Error:", err);
            setOriginalWarehouse(null);
            setEditWarehouse(null);
        }
    };

    const calculateCapacitySummary = (warehouse) => {

        const summary = warehouse?.capacity_summary?.[0] || {};

        const total = Number(summary.total_capacity) || 0;
        const occupancy = Number(summary.occupancy) || 0;
        const available = total - occupancy;

        const occupancy_percentage = total > 0 ? (occupancy / total) * 100 : 0;
        const available_percentage = total > 0 ? (available / total) * 100 : 0;

        return [
            {
                total_capacity: total,
                occupancy: occupancy,
                available: available,
                occupancy_percentage: Number(occupancy_percentage.toFixed(2)),
                available_percentage: Number(available_percentage.toFixed(2)),
            }
        ];
    };

    const handleSaveChanges = async () => {
        try {
            const formData = new FormData();

            const updatedWarehouse = {
                ...EditWarehouse,
                capacity_summary: calculateCapacitySummary(EditWarehouse),
            };

            Object.keys(updatedWarehouse).forEach((key) => {
                if (key === "capacity_summary") {
                    formData.append(key, JSON.stringify(updatedWarehouse[key]));
                } else {
                    formData.append(key, updatedWarehouse[key]);
                }
            });

            const response = await fetch(
                `${BASE_API}/apis/WarehouseUpdate.php`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include"
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                setIsEditingUser(false);
                fetchWarehouselist();
                setOriginalWarehouse(EditWarehouse);
                Swal.fire({
                    icon: "success",
                    title: t("updatedSuccessfully"),
                    text: t("warehouseDetailsUpdated"),
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: t("ok"),
                });
            } else {
                console.log("Update failed");
                Swal.fire({
                    icon: "error",
                    title: "Update Failed",
                    text: result.message || "Something went wrong!",
                });
            }

        } catch (err) {
            console.error("Fetch Error:", err);
        }
    };

    const handleWarehouseChange = (field, value) => {
        setEditWarehouse({
            ...EditWarehouse,
            [field]: value,
        });
    };

    const handleRegion = (values) => {
        setSelectedRegion(values);
        fetchwarehouseDD(values);
    }

    const fetchwarehouseDD = async (values) => {
        try {
            const formData = new FormData();
            formData.append("region_id", values);

            const response = await fetch(
                `${BASE_API}/apis/getWarehouse.php`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include"
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                setWarehouseDD(result?.data);
            } else {
                setWarehouseDD([]);
            }
        } catch (err) {
            console.error("Fetch Error:", err);
            setWarehouseDD([]);
        }
    }

    const isChanged = JSON.stringify(EditWarehouse) !== JSON.stringify(originalWarehouse);

    const handleClose = () => {
        if (isChanged) {
            Swal.fire({
                icon: "warning",
                title: t("unsavedChangesTitle"),
                text: t("unsavedChanges"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t("yesClose"),
                cancelButtonText: t("cancel")
            }).then((result) => {
                if (result.isConfirmed) {
                    onClose();
                    setOriginalWarehouse(null);
                    setEditWarehouse(null);
                    form.resetFields();
                }
            });
        } else {
            onClose();
            setOriginalWarehouse(null);
            setEditWarehouse(null);
        }
    };

    const handleCreateRegion = async () => {
        try {
            const formData = new FormData();

            const values = regionForm.getFieldsValue();

            formData.append("Region_Name", values.regname);
            formData.append("user_id", userDetails?.id);

            const response = await fetch(
                `${BASE_API}/apis/createRegion.php`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include"
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                setShowRegionModal(false);
                Swal.fire({
                    icon: "success",
                    title: t("updatedSuccessfully"),
                    text: t("warehouseDetailsUpdated"),
                });
                form.resetFields();
            } else {
                console.log("Creation failed");
                Swal.fire({
                    icon: "error",
                    title: "Creation Failed",
                    text: result.message || "Something went wrong!",
                });
            }

        } catch (err) {
            console.error("Fetch Error:", err);
        }
    }

    return (
        <Drawer
            width={800}
            onClose={handleClose}
            open={open}
            // destroyOnClose
            title={
                <div className="d-flex justify-content-between align-items-center">
                    <span className="text-primary" style={{ fontSize: "18px", fontWeight: 600 }}>
                        {t("modifyWarehouse")}
                    </span>

                    <div className="d-flex gap-2">
                        <Button
                            type="default"
                            size="small"
                            onClick={() => setShowRegionModal(true)}
                            title={t("addRegion")}

                        >
                            + {t("newRegion")}
                        </Button>
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => setShowOffcanvas(true)}
                        >
                            + {t("newWarehouse")}
                        </Button>
                    </div>
                </div>
            }
        >
            {/* 🔹 Top Selection Section */}
            <Form layout="vertical" form={form} onFinish={onsubmit}>
                <Row gutter={16}>
                    <Col span={10}>
                        <Form.Item
                            label={t("selectRegion")}
                            name="region"
                            rules={[{ required: true, message: t("pleaseSelectRegion") }]}
                        >
                            <Select placeholder={t("chooseRegion")} value={selectedRegion}
                                onChange={handleRegion}
                            >
                                {dropdown?.map((item, index) => (
                                    <Option key={index} value={item?.region_id}>
                                        {item?.region_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label={t("selectWarehouse")}
                            name="warehouse"
                            rules={[{ required: true, message: t("pleaseSelectWarehouse") }]}
                        >
                            <Select placeholder={t("chooseWarehouse")} value={selectedWarehouse}
                                onChange={(value) => setSelectedWarehouse(value)}
                            >
                                {WarehouseDD?.map((item, index) => (
                                    <Option key={index} value={item.Wh_id}>
                                        {item.wh_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4} className="d-flex align-items-center">
                        <Button type="primary" htmlType="submit" block>
                            {t("submit")}
                        </Button>
                    </Col>
                </Row>
            </Form>

            {/* 🔹 Small Info Line */}
            <Text type="secondary">
                {t("updateWarehouseInfo")}
            </Text>

            <Divider />

            {/* 🔹 Warehouse Details Section */}
            {EditWarehouse && (
                <div className="container-fluid mt-3">

                    {/* 🔹 Warehouse Details */}
                    {/* Header */}
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className="text-primary fw-bold">
                                <i className="bi bi-building me-2"></i>
                                {t("warehouseDetails")}
                            </h5>
                            <small className="text-muted">
                                {t("updateWarehouseInfo")}
                            </small>
                        </div>

                        {/* Save Button */}
                        <div className="">
                            <button className="btn btn-sm btn-primary" onClick={handleSaveChanges} disabled={!isChanged}>
                                <i className="bi bi-save me-2"></i>
                                {t("saveChanges")}
                            </button>
                        </div>

                    </div>

                    <div className="row g-3">

                        {/* Region */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-geo-alt me-2 text-secondary"></i>
                                {t("region")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.region}
                                onChange={(e) =>
                                    handleWarehouseChange("region", e.target.value)
                                }
                            />
                        </div>

                        {/* Warehouse Name */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-building me-2 text-secondary"></i>
                                {t("warehouseName")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.wh_name}
                                onChange={(e) =>
                                    handleWarehouseChange("wh_name", e.target.value)
                                }
                            />
                        </div>

                        {/* Total Capacity */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-box me-2 text-secondary"></i>
                                {t("totalCapacity")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse?.capacity_summary[0]?.total_capacity}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setEditWarehouse(prev => ({
                                        ...prev,
                                        capacity_summary: [
                                            {
                                                ...prev.capacity_summary?.[0],
                                                total_capacity: value
                                            }
                                        ]
                                    }));
                                }}
                            />
                        </div>

                        {/* Occupied */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-archive me-2 text-secondary"></i>
                                {t("occupied")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse?.capacity_summary[0]?.occupancy}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setEditWarehouse(prev => ({
                                        ...prev,
                                        capacity_summary: [
                                            {
                                                ...prev.capacity_summary?.[0],
                                                occupancy: value
                                            }
                                        ]
                                    }));
                                }}
                            />
                        </div>

                        {/* Address - Full Width */}
                        <div className="col-12">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-map me-2 text-secondary"></i>
                                {t("address")}
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={EditWarehouse.address}
                                onChange={(e) =>
                                    handleWarehouseChange("address", e.target.value)
                                }
                            />
                        </div>

                        {/* {district } */}
                        <div className="col-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-map me-2 text-secondary"></i>
                                {t("district")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.district}
                                onChange={(e) =>
                                    handleWarehouseChange("district", e.target.value)
                                }
                            />
                        </div>

                        {/* {pincode } */}
                        <div className="col-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-map me-2 text-secondary"></i>
                                {t("pincode")}
                            </label>
                            <input
                                maxLength={6}
                                type="text"
                                className="form-control"
                                value={EditWarehouse.pincode}
                                onChange={(e) =>
                                    handleWarehouseChange("pincode", e.target.value)
                                }
                            />
                        </div>

                        {/* {EditWarehouse.ofc_phn && */}
                        <div className="col-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-telephone-fill me-2 text-secondary"></i>
                                {t("officePhoneNumber")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.ofc_phn}
                                onChange={(e) =>
                                    handleWarehouseChange("ofc_phn", e.target.value)
                                }
                            />
                        </div>
                        {/* } */}

                        {/* map */}
                        <div className="col-12">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-geo-alt-fill me-2 text-secondary"></i>
                                {t("currentLocation")}
                            </label>
                            <iframe
                                src={EditWarehouse?.map}
                                width="100%"
                                height="400"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>

                            <div style={{ marginTop: '10px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <label className="form-label fw-semibold mb-0 d-flex align-items-center">
                                        <i className="bi bi-geo-alt-fill me-2 text-secondary"></i>
                                        {t("changeLocation")}
                                    </label>

                                    {/* Demo / Video Icon */}
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn btn-sm text-primary p-0 me-1"
                                            onClick={() => setShowVideo(true)}
                                            title={t("watchDemo")}
                                        >
                                            <i className="bi bi-play-circle-fill" style={{ fontSize: '1.2rem' }}></i>
                                        </button>
                                        <span className="fs-6 text-secondary mb-0">{t("demo")}</span>
                                    </div>
                                </div>


                                <div className="d-flex align-items-center my-2">
                                    <Input
                                        placeholder={t("pasteGoogleMapsUrl")}
                                        value={inputUrl}
                                        onChange={(e) => setInputUrl(e.target.value)}
                                    />
                                    <Button
                                        type="primary"
                                        onClick={handleUpdateMap}
                                        style={{ marginLeft: '5px' }}
                                    >
                                        {t("updateMap")}
                                    </Button>


                                </div>

                                {/* Bootstrap Modal for Video */}
                                <Modal
                                    show={showVideo}
                                    onHide={() => setShowVideo(false)}
                                    size="lg"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>{t("demoVideo")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="ratio ratio-16x9">
                                            <iframe
                                                src={`${BASE_API}/images/demovideo/map.mp4`}
                                                title={t("demoVideo")}
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>

                        {/* images */}
                        {/* <div className="col-12">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-images me-2 text-secondary"></i>
                                Images
                            </label>

                            <div className="d-flex flex-wrap gap-2">
                                {images.map((img, idx) => (
                                    <img
                                        key={idx}
                                        src={img}
                                        alt={`thumb-${idx}`}
                                        className="img-thumbnail"
                                        style={{ width: "100px", height: "100px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => openModal(idx)}
                                    />
                                ))}

                                <button
                                    type="button"
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                    style={{ width: "100px", height: "100px" }}
                                    onClick={addImage}
                                >
                                    <i className="bi bi-plus-lg fs-3"></i>
                                </button>
                            </div>

                            {showModal && images.length > 0 && (
                                <div
                                    className="modal fade show"
                                    style={{ display: "block" }}
                                    tabIndex="-1"
                                    aria-labelledby="imageModalLabel"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                        <div className="modal-content position-relative">
                                            <div className="modal-body p-0">
                                                <img
                                                    src={images[currentIndex]}
                                                    alt={`img-${currentIndex}`}
                                                    className="img-fluid w-100"
                                                />

                                                <button
                                                    type="button"
                                                    className="btn btn-danger position-absolute top-0 end-0 m-2"
                                                    onClick={removeImage}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary position-absolute top-50 start-0 translate-middle-y"
                                                    onClick={prevImage}
                                                >
                                                    <i className="bi bi-chevron-left"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary position-absolute top-50 end-0 translate-middle-y"
                                                    onClick={nextImage}
                                                >
                                                    <i className="bi bi-chevron-right"></i>
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn-close position-absolute top-0 start-0 m-2"
                                                    onClick={() => setShowModal(false)}
                                                    aria-label="Close"
                                                ></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div> */}

                    </div>


                    <Divider />

                    {/* 🔹 User Details Card */}
                    <Col xs={24} md={10}>
                        <div className="card shadow border-0 rounded-4">

                            {/* Header */}
                            <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
                                <span>{t("userDetails")}</span>

                                <i
                                    className={`bi ${isEditingUser ? "bi-x-square" : "bi-pencil-square"}`}
                                    style={{ cursor: "pointer", fontSize: "20px", transition: "0.2s" }}
                                    onClick={() => {
                                        setIsEditingUser(!isEditingUser);
                                    }}
                                ></i>
                            </div>

                            <div className="card-body">

                                <div className="row g-3">
                                    {[
                                        { label: t("name"), field: "name", icon: "bi-person-fill", color: "text-primary" },
                                        { label: t("email"), field: "email", icon: "bi-envelope-fill", color: "text-danger" },
                                        { label: t("phone"), field: "phone_no", icon: "bi-telephone-fill", color: "text-success" }
                                    ].map((item) => (
                                        <div key={item.field} className={isEditingUser ? "col-12" : "col-12 m-0"}>

                                            <label className="form-label small m-0 fw-semibold">
                                                <i className={`bi ${item.icon} me-2 ${item.color}`}></i>
                                                {item.label}:
                                            </label>

                                            {isEditingUser ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={EditWarehouse[item.field] || ""}
                                                    onChange={(e) =>
                                                        handleWarehouseChange(item.field, e.target.value)
                                                    }
                                                />
                                            ) : (
                                                <span className="ms-2 text-muted">
                                                    {EditWarehouse[item.field] || ""}
                                                </span>
                                            )}
                                        </div>
                                    ))}

                                    <div className={isEditingUser ? "col-12" : "col-12 m-0"}>
                                        <label className="form-label small m-0 fw-semibold">
                                            <i className="bi bi-person-badge-fill me-2 text-warning"></i>
                                            {t("role")}
                                        </label>

                                        {isEditingUser ? (
                                            <Select
                                                value={EditWarehouse.role}
                                                onChange={(value) =>
                                                    handleWarehouseChange("role", value)
                                                }
                                                style={{ width: "100%" }}
                                            >
                                                <Option value="Manager">{t("warehouseManager")}</Option>
                                            </Select>
                                        ) : (
                                            <span className="ms-2 text-muted">
                                                {EditWarehouse?.role || ""}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>

                </div>
            )}

            <NewWarehouse
                show={showOffcanvas}
                region={dropdown}
                handleCanvaClose={() => setShowOffcanvas(false)}
                fetchWarehouselist={fetchWarehouselist}
            />

            <Modal show={showRegionModal} onHide={() => setShowRegionModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("addRegionModalTitle")}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form form={regionForm} layout="vertical" >
                        <Form.Item
                            label={t("addRegionModalLabel")}
                            name="regname"
                            rules={[{ required: true, message: t("addRegionModalValidation") }]}
                        >
                            <Input placeholder={t("addRegionModalPlaceholder")} />
                        </Form.Item>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => {
                        regionForm.resetFields();
                        setShowRegionModal(false);
                    }}>
                        {t("addRegionModalCancel")}
                    </Button>
                    <Button type="primary" onClick={handleCreateRegion} >
                        {t("addRegionModalCreate")}
                    </Button>
                </Modal.Footer>
            </Modal>

        </Drawer >
    );
};

export default ModifyWarehouseDrawer;